// extracted by mini-css-extract-plugin
module.exports = {"form-actions":"index__form-actions__3EDaq","btn-submit":"index__btn-submit__1SKyR"};